export const twitterDiscordHeader = "Let's Connect!";

export const twitterDiscordSubheader = 'Give us your Twitter and Discord handles so we can stay in touch about new quests, technical issues, and quest payouts!';
